import React, { FC } from 'react'

import { ScoreStatusSelect } from '../../ScoreStatusSelect'

import { getRankColor } from '../../../../../helpers/rank'

import {
  IScoreCardInterface,
  IScoreCardSection,
} from '../../../../../models/score-cards/score-cards.interface'
import { UseFormWatch } from 'react-hook-form/dist/types/form'
import {
  IRegistrationByDayInterface,
} from '../../../../../models/registrations-by-day/registrationByDay.interface'

interface CustomScoringModalHeaderProps {
  isLocked: boolean
  showLockedModal: () => void
  sections: IScoreCardSection[]
  watch: UseFormWatch<IScoreCardInterface>
  editable: boolean
  row: IRegistrationByDayInterface
  setRow: (value: IRegistrationByDayInterface) => void
}

export const CustomScoringModalHeader: FC<CustomScoringModalHeaderProps> = ({
  isLocked,
  showLockedModal,
  sections,
  watch,
  editable,
  row,
  setRow,
}) => {
  return (
    <div className="pb-6 mb-6 border-b border-b-SeabiscuitLightThemeColorD3">
      <div className="flex items-center justify-between gap-2 mb-5">
        <h4 className="font-bold text-lg md:text-[25px]">{watch('name')}</h4>
        <ScoreStatusSelect
          value={row}
          setValue={setRow}
          showLockedModal={showLockedModal}
          isLocked={isLocked}
          editable={editable}
        />
      </div>
      <div className="flex gap-3 justify-between">
        <div
          className="flex items-center justify-center p-2 w-[62px] bg-SeabiscuitGrayThemeColor rounded-md font-bold text-white"
          style={{ background: getRankColor(Number(row.score?.rank)) }}
        >
          {row?.score?.rank || 0}
        </div>
        <div className="flex-1 flex flex-col gap-2.5">
          {row.score?.scoreStatus === 'Withdrew' ? (
            <div className="flex flex-wrap gap-1 items-center justify-end px-4 py-2 w-full bg-SeabiscuitGrayThemeColor rounded-md">
              <div className="whitespace-nowrap flex justify-between gap-2 md:gap-5 items-center">
                <p className="rounded-full py-2 px-4 bg-white">Withdrew</p>
              </div>
            </div>
          ) : (
            sections?.map((section) => {
              const showSection = section.type !== 'jump off' || watch('showJumpOff')
              return (
                showSection &&
                row.score?.scoreStatus !== 'Withdrew' && (
                  <div
                    key={section.id}
                    className="flex flex-wrap gap-1 items-center justify-between px-4 py-2 w-full bg-SeabiscuitGrayThemeColor rounded-md"
                  >
                    {section.name}
                    <div className="whitespace-nowrap flex justify-between gap-2 md:gap-5 items-center">
                      <p>{section.totalFaultsStatus || `${section.totalTime} seconds`}</p>
                      <p className="rounded-full py-2 px-4 bg-white">
                        {section.totalFaultsCount ?? 0}F
                        {watch('scoreCardType') !== 'optimum' &&
                          `/ ${section.totalTimeFaults ?? 0}TF`}
                      </p>
                    </div>
                  </div>
                )
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}
